<template>
  <md-popup
      v-model="value"
      @beforeHide="close"
      position="bottom"
      :class="{ 'has-search': hasSearch, 'is-dark': isLongVideo }"
  >
    <div class="title" v-if="hasSearch">
      <div>
        <div>大家都在搜： <span class="green">日本小姐姐</span><i class="small-search-icon"/></div>
        <i class="close" @click="close"/>
      </div>
      <span>{{ total }} {{ $t('commentCount') }}</span>
    </div>
    <div class="title1" v-else>
      <span>{{ total }} {{ $t('commentCount') }}</span>
      <i class="close" @click="close"/>
    </div>
    <md-scroll-view
        ref="scrollView"
        :scrolling-x="false"
        :auto-reflow="true"
        @refreshing="onRefresh"
        @end-reached="onEndReached"
    >
      <!--下拉刷新组件-->
      <md-scroll-view-refresh
          slot="refresh"
          slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
          :scroll-top="scrollTop"
          :is-refreshing="isRefreshing"
          :is-refresh-active="isRefreshActive"
          :refreshText="$t('refreshText')"
          :refreshActiveText="$t('refreshActiveText')"
          :refreshingText="$t('refreshingText')"
      ></md-scroll-view-refresh>
      <div class="list">
        <ReplyItem v-for="(item) in commentList" :key="item.id"
                   :comment-data="item"
                   @loadMore="onLoadMoreSub($event)"
                   @reply="onReply($event)"
                   @del="onDel($event)"
                   @expand="item.expanded = true"
                   @image="onPreview($event)"
                   @collapse="item.expanded = false"
                   :is-dark="isLongVideo"
        />
      </div>
      <md-scroll-view-more
          slot="more"
          :is-finished="isFinished"
          :loading-text="$t('loading')"
          :finished-text="$t('noMoreData')"
      >
      </md-scroll-view-more>
    </md-scroll-view>
    <!-- showPopup = true -->
    <div class="input-wrapper" @click="showPopupDialog('comment')">
      <input
          readonly
          v-model="content"
          :placeholder="$t('commentPlaceholder')"
          maxlength="60"
      />
      <!--      <div class="emoji" />-->
      <!--      <div class="btn" @click="comment">{{ $t('commentSend') }}</div>-->
      <div class="action-wrap">
        <!-- <img class="refer" src="./assets/@.png" alt=""> -->
        <img class="emoji"
             src="./assets/emoji.png" alt="" @click.stop="showPopupDialog('emo')"/>
        <img class="send-image" src="./assets/send-image.png" alt="" @click.stop="showPopupDialog('upload')" />
      </div>
    </div>

    <DelWarn :show="showDelConfirm"
             @confirm="doDelComment"
             @cancel="showDelConfirm = false"/>

    <RickTextComment @comment="doComment($event)"
                     :show-popup="showPopup"
                     :replyName="replyName"
                     :isFileSendRich="isFileSendRich"
                     :isOpenEmojiRich="isOpenEmojiRich"
                     v-if="showPopup"
                     @close="showPopup = false"
                     @share="onShare"
    />
    <md-dialog
        class="preview-image-dialog"
        :value="isShowImage"
        :closable="false"
        :mask-closable="true"
    >
      <img :src="previewImageUrl" alt="" @click="isShowImage = false">
    </md-dialog>
  </md-popup>
</template>

<script>
import { getComment, addComment, getCommentReply, delComment } from '@api/shortVideo';
import { getLongVideoComment, addLongVideoComment, getLongVideoCommentReply, delLongVideoComment } from '@api/longVideo';
import DelWarn from '@components/Comment/components/DelWarn';
import emojiData from '@/utils/emoji';
import ReplyItem from '@components/Comment/components/ReplyItem';
import RickTextComment from '@components/RickTextComment';
import { Dialog } from 'mand-mobile';

export default {
  name: 'Comment',
  components: {
    RickTextComment,
    ReplyItem,
    DelWarn,
    [Dialog.name]: Dialog
  },
  props: {
    vid: {
      type: Number,
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    },
    isLongVideo: {
      type: Boolean,
      default: false
    },
    hasSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emojiData: emojiData,
      showDelConfirm: false,
      showPopup: false,
      selected: [],
      selectedNick: [],
      commentList: [],
      page: 1,
      inputText: '',
      isShowEmoji: false,
      pageSize: 10,
      content: '',
      previewImageUrl: '',
      isShowImage: false,
      delData: {},
      totalPageCount: 0,
      isFinished: false,
      isSending: false,
      total: 0,
      scrollToTarget: false,
      replyId: '',
      isReply: '',
      mainReplyId: '',
      replyName: '',
      isOpenEmojiRich: false,
      isFileSendRich: false
    };
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  watch: {
    value () {
      this.fileSend = {};
    },
    vid: {
      handler (val) {
        if (val) {
          this.getCommentList();
        }
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    onPreview (url) {
      this.previewImageUrl = url;
      this.isShowImage = true;
    },
    showPopupDialog (type = 'comment') {
      this.showPopup = true;
      if (type === 'emo') {
        this.isOpenEmojiRich = true;
      } else if (type === 'upload') {
        this.isFileSendRich = true;
      }
    },
    doDelComment () {
      let api = delComment;
      if (this.isLongVideo) {
        api = delLongVideoComment;
      }

      api({ id: this.delData.id })
        .then(res => {
          if (res.result === 200000) {
            if (this.delData.mainId) {
              const targetList = this.commentList.find(item => item.id === this.delData.mainId);
              console.log(...targetList.replays.list);
              targetList.replays.list.splice(
                targetList.replays.list.findIndex(item => item.id === this.delData.id),
                1
              );
              // targetList.replays.list = [...targetList.replays.list];
              // this.commentList = [...this.commentList];
            } else {
              const index = this.commentList.findIndex(item => item.id === this.delData.id);
              this.commentList.splice(
                index,
                1
              );
            }

            this.commentList = [...this.commentList];

            this.showDelConfirm = false;
          }
        });
    },
    onDel (data) {
      console.log('del id', data.id);
      this.delData = data;
      this.showDelConfirm = true;
    },
    onLoadMoreSub (item) {
      const params = {
        page: item.replays.page + 1,
        page_size: 3,
        comment_id: item.id
      };

      let api = getCommentReply;
      if (this.isLongVideo) {
        api = getLongVideoCommentReply;
      }

      api(params).then(res => {
        if (res.result === 200000) {
          const target = this.commentList.find(t => t.id === item.id);
          if (target) {
            target.replays.list = target.replays.list.concat(res.data.list);
            target.replays.page += 1;
          }
          target.expanded = true;
        }
      });
    },
    onReply (comment) {
      this.isReply = true;
      this.replyId = comment.id;
      this.replyName = comment.nick_name;
      this.mainReplyId = comment.main.id;
      this.showPopup = true;
    },
    close () {
      this.$emit('input', false);
    },
    onShare () {
      this.showPopup = false;
      this.$emit('share', false);
    },
    getCommentList () {
      const params = {
        vid: this.vid,
        page: this.page,
        page_size: this.pageSize
      };

      if (this.$route.query.comment && this.page === 1) {
        params.comment_id = this.$route.query.comment;
        this.scrollToTarget = true;
      }

      let api = getComment;
      if (this.isLongVideo) {
        api = getLongVideoComment;
      }
      api(params).then(res => {
        if (res.result === 200000) {
          this.commentList = this.commentList.concat(res.data.list.list
            .map(item => {
              try {
                item.centos = JSON.parse(item.centos);
              } catch (e) {
                item.centos = {};
              }
              item.expanded = item.replays.list.length > 3;
              return item;
            }));
          this.totalPageCount = res.data.list.pageCount;
          this.total = res.data.list.totalCount;
          this.page = res.data.list.page;

          if (this.page >= this.totalPageCount) {
            this.isFinished = true;
          }
          if (this.scrollToTarget) {
            setTimeout(() => {
              let offsetTop = 0;
              if (document.querySelector('#reply-anchor')) {
                offsetTop = document.querySelector('#reply-anchor').offsetTop;
              } else if (document.querySelector('#comment-anchor')) {
                offsetTop = document.querySelector('#comment-anchor').offsetTop;
              }

              this.$refs.scrollView.scrollTo(0, offsetTop);
              this.scrollToTarget = false;
            }, 200);
          }
        }
        this.$refs.scrollView.finishRefresh();
        this.$refs.scrollView.finishLoadMore();
      });
    },
    doComment (centos) {
      const url = centos.url;
      delete centos.url;
      const params = {
        vid: this.vid,
        centos: JSON.stringify(centos)
      };

      if (this.replyId) {
        params.fid = this.replyId;
      }

      let api = addComment;
      if (this.isLongVideo) {
        api = addLongVideoComment;
      }

      api(params).then(async res => {
        if (res.result === 200000) {
          if (this.isReply) {
            const target = this.commentList.find(item => item.id === (this.mainReplyId || this.replyId));
            if (target) {
              const commentItem = {
                uid: this.userInfo.uid,
                id: res.data.data,
                avatar: this.userInfo.avatar,
                centos: {
                  ...centos,
                  pic: url
                    ? [{
                        url
                      }]
                    : []
                },
                nick_name: this.userInfo.username,
                created_at: new Date().getTime(),
                fid: this.replyId,
                replayed_user: this.replyName
              };
              target.expanded = true;

              target.replays.list.unshift(commentItem);
              console.log(target.replays.list);
            }
          } else {
            this.commentList.unshift({
              uid: this.userInfo.uid,
              id: res.data.data,
              avatar: this.userInfo.avatar,
              expanded: false,
              centos: {
                ...centos,
                pic: url
                  ? [{
                      url
                    }]
                  : []
              },
              replays: {
                list: [],
                page: 1
              },
              nick_name: this.userInfo.username,
              created_at: new Date().getTime()
            });
            console.log(this.commentList);
            this.commentList = [...this.commentList];
            this.total++;
          }
          this.showPopup = false;
          this.isOpenEmoji = false;
          this.isFileSendRich = false;
          this.isReply = false;
          this.mainReplyId = '';
          this.replyId = '';
          this.replyName = '';
          this.$emit('commentSuccess', this.total);
          this.fileSend = {};
        } else {
          this.$toast.failed(res.msg);
        }
      });
    },
    goUserDetail (uid) {
      this.$router.push({ path: '/userDetail', query: { uid } });
    },
    onRefresh () {
      this.commentList = [];
      this.page = 1;
      this.getCommentList();
    },
    onEndReached () {
      if (this.isFinished) return;
      this.page += 1;
      this.getCommentList();
    }
  }
};
</script>

<style lang="scss" scoped>
.md-popup {
  z-index: 100001;
  top: auto;
  right: auto;
  left: auto;
  width: 100%;
  /deep/ .md-popup-mask {
    background-color: transparent;
  }
  /deep/ .md-popup-box {
    padding: 16px 16px 21px;
    background: #1C1E23;
    border-radius: 8px 8px 0 0;
    overflow: hidden;

    .title {
      display: flex;
      flex-direction: column;

      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 29px;
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 14px;
        line-height: 1;
        color: rgba(22, 22, 22, 0.6);

        .green {
          color: #32B8AF;
        }

      }

      > span {
        text-align: center;
        font-family: 'PingFang SC';
        font-size: 12px;
        line-height: 1;
        color: rgba(22, 22, 22, 0.8);
      }
    }

    .title1 {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      span {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        font-family: 'PingFang SC';
        font-size: 12px;
        line-height: 12px;
        color: #FFFFFFCC;
      }
    }

    .close {
      width: 18px;
      height: 18px;
      background: url("~@assets/imgs/public/closeIconWhite.png") 0 0/100% 100%;
    }

    .md-scroll-view {
      //height: 366px;
      height: 410px;
    }

    /deep/ .scroll-view-more {
      //padding-bottom: 50px;
      .md-scroll-view-more {
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 13px;
        line-height: 22px;
        text-align: center;
        color: rgba(22, 22, 22, 0.7);
      }
    }

    .input-wrapper {
      position: absolute;
      bottom: 13px;
      display: flex;
      align-items: center;
      width: 347px;
      z-index: 100;
      height: 30px;
      border-radius: 26px;
      overflow: hidden;
      padding-right: 15px;
      background: #393948;
      input {
        //width: 100%;
        flex: 1;
        height: 100%;
        padding-left: 12px;
        padding-right: 40px;
        background: #393948;

        &::placeholder {
          font-family: 'PingFang SC';
          font-weight: 400;
          font-size: 14px;
          line-height: 14px;
          color: rgba(255, 255, 255, 0.5);
        }
      }

      .action-wrap {
        display: flex;
        width: 100%;
        justify-content: flex-end;

        img {
          width: 24px;
          height: 24px;
          margin-left: 10px;
        }
      }

    }
  }
}

.has-search {
  /deep/ .md-popup-box {
    padding-top: 21px;
  }
}

//.is-dark {
//  /deep/ .md-popup-box {
//    background-color: #1C1E23;
//
//    .title1 {
//      span {
//        color: rgba(255, 255, 255, 0.8);
//      }
//    }
//
//    .close {
//      width: 24px;
//      height: 24px;
//      background: url('./assets/whiteCloseIcon.png') 0 0/100% 100%;
//    }
//
//    .input-wrapper {
//      background: rgba(255, 255, 255, 0.15);
//
//      input {
//        background: rgba(255, 255, 255, 0.15);
//        color: #FFF;
//
//        &::placeholder {
//          color: rgba(255, 255, 255, 0.5);
//        }
//      }
//    }
//
//    /deep/ .scroll-view-more {
//      //padding-bottom: 50px;
//      .md-scroll-view-more {
//        font-family: 'PingFang SC';
//        font-weight: 400;
//        font-size: 13px;
//        line-height: 22px;
//        text-align: center;
//        color: #FFF;
//      }
//    }
//  }
//}
//
.list {
  margin-top: 10px;
}

</style>
<style lang="scss">
.preview-image-dialog {

  .md-popup {
    z-index: 9999999;
  }

  .md-dialog-content {
    height: 100vh;
    width: 100vw;
    background-color: transparent !important;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }

    .md-dialog-body {
      border-bottom: none;
      padding: 0;
      height: 100%;
      width: 100%;
      max-height: unset;
    }

    .md-dialog-actions {
      display: none;
    }
  }
}
</style>
